export enum PriceEntryType {
    Standard = 'standard',
    OnRequest = 'on_request',
}